import { useState } from "react";
import { LayoutDashboard, ShoppingBag, Users, MessageSquare, Images, Mail, Settings as SettingsIcon, LogOut, Palette, Inbox, UserPlus, Workflow, Share2, Megaphone, Zap, PenTool, TrendingUp, CalendarCheck, QrCode } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import Overview from "@/components/admin/Overview";
import OrdersTab from "@/components/admin/OrdersTab";
import ReferralsTab from "@/components/admin/ReferralsTab";
import TestimonialsTab from "@/components/admin/TestimonialsTab";
import GalleryTab from "@/components/admin/GalleryTab";
import PromoTab from "@/components/admin/PromoTab";
import SettingsTab from "@/components/admin/SettingsTab";
import MessagesTab from "@/components/admin/MessagesTab";
import BookingsTab from "@/components/admin/BookingsTab";
import LeadsTab from "@/components/admin/LeadsTab";
import FlowsTab from "@/components/admin/FlowsTab";
import SocialTab from "@/components/admin/SocialTab";
import AdsTab from "@/components/admin/AdsTab";
import AutomationTab from "@/components/admin/AutomationTab";
import ContentGeneratorTab from "@/components/admin/ContentGeneratorTab";
import GrowthTab from "@/components/admin/GrowthTab";
import ReviewQRTab from "@/components/admin/ReviewQRTab";

const TABS = [
  { id: "overview", label: "Overview", icon: LayoutDashboard, C: Overview },
  { id: "orders", label: "Orders", icon: ShoppingBag, C: OrdersTab },
  { id: "messages", label: "Messages", icon: Inbox, C: MessagesTab },
  { id: "bookings", label: "Event Bookings", icon: CalendarCheck, C: BookingsTab },
  { id: "referrals", label: "Referrals", icon: Users, C: ReferralsTab },
  { id: "reviews", label: "Reviews", icon: MessageSquare, C: TestimonialsTab },
  { id: "review-qr", label: "Review QR", icon: QrCode, C: ReviewQRTab },
  { id: "gallery", label: "Gallery", icon: Images, C: GalleryTab },
  { id: "promo", label: "Email List", icon: Mail, C: PromoTab },
  { id: "growth", label: "Growth Engine", icon: TrendingUp, C: GrowthTab, group: "Marketing" },
  { id: "automation", label: "Automation", icon: Zap, C: AutomationTab },
  { id: "content", label: "Content Generator", icon: PenTool, C: ContentGeneratorTab },
  { id: "leads", label: "Leads", icon: UserPlus, C: LeadsTab },
  { id: "flows", label: "Email Flows", icon: Workflow, C: FlowsTab },
  { id: "social", label: "Social", icon: Share2, C: SocialTab },
  { id: "ads", label: "Ad Optimizer", icon: Megaphone, C: AdsTab },
  { id: "settings", label: "Settings", icon: SettingsIcon, C: SettingsTab },
];

export default function Admin() {
  const [tab, setTab] = useState("overview");
  const { user, logout } = useAuth();
  const Active = TABS.find((t) => t.id === tab).C;

  return (
    <div className="min-h-screen bg-grid" data-testid="admin-dashboard">
      <div className="flex flex-col lg:flex-row">
        {/* sidebar */}
        <aside className="lg:w-64 lg:min-h-screen bg-ink text-cream border-r-[3px] border-ink lg:sticky lg:top-0">
          <div className="p-5 flex items-center gap-2 border-b border-cream/20">
            <span className="grid place-items-center w-10 h-10 rounded-xl bg-bubble border-2 border-cream"><Palette className="w-5 h-5 text-white" /></span>
            <div>
              <div className="font-display font-bold leading-none">Owner</div>
              <div className="text-xs text-cream/60 truncate max-w-[140px]">{user?.email}</div>
            </div>
          </div>
          <nav className="p-3 flex lg:flex-col gap-1 overflow-x-auto">
            {TABS.map((t) => (
              <div key={t.id} className="contents">
                {t.group && <div className="hidden lg:block px-4 pt-4 pb-1 text-[10px] uppercase tracking-widest font-bold text-cream/40">{t.group}</div>}
                <button onClick={() => setTab(t.id)} data-testid={`admin-tab-${t.id}`}
                  className={`flex items-center gap-3 px-4 py-3 rounded-xl font-display font-semibold whitespace-nowrap transition-colors ${
                    tab === t.id ? "bg-sun text-ink" : "hover:bg-cream/10 text-cream/80"
                  }`}>
                  <t.icon className="w-5 h-5" /> {t.label}
                </button>
              </div>
            ))}
            <button onClick={logout} data-testid="admin-logout"
              className="flex items-center gap-3 px-4 py-3 rounded-xl font-display font-semibold text-bubble hover:bg-cream/10">
              <LogOut className="w-5 h-5" /> Logout
            </button>
          </nav>
        </aside>

        <main className="flex-1 p-5 sm:p-8 max-w-full overflow-hidden">
          <Active />
        </main>
      </div>
    </div>
  );
}
